import React from 'react'
import { Link } from 'react-router-dom'

const fullMenu = [

  


{
    name: 'Analytics',
    path: '/dashboard/analytics',
    icon: 'folder',
    dataTargetId: '#analytics'
  },
  {
    name: 'Master',
    path: '/master',
    icon: 'layers',
    dataTargetId: '#master',
    submenu: [
      // { name: 'New Customer', path: '/master/newcustomer' },
      // { name: 'New Supplier', path: '/master/newsupplier' },
      // { name: 'New Table', path: '/master/table' },
         { name: 'Ticket Pricing', path: '/master/ticketpricing' },

      { name: 'New Category', path: '/master/newcategory' },
      { name: 'New Sub Category', path: '/master/newsubcategory' },
      { name: 'Payment Options', path: '/master/paymentoptions' },

    ]
  },
  // {
  //   name: 'Inventory',
  //   path: '/inventory',
  //   icon: 'store',
  //   dataTargetId: '#inventory',
  //   submenu: [
  //     { name: 'Add New Item', path: '/inventory/newItem' },
  //     { name: 'Add New Stock', path: '/inventory/newStock' },
  //     { name: 'New Product', path: '/inventory/newproduct' },
  //     { name: 'Stock Report', path: '/inventory/stockreports' },


  //   ]
  // },

  // {
  //   name: 'Sale',
  //   path: '/sale',
  //   icon: 'shopping-cart',
  //   dataTargetId: '#property',
  //   submenu: [
  //      { name: 'Ticket Billing', path: '/pos/ticketbilling' },
  //     { name: 'POS', path: '/sale/pos' },
  //     { name: 'New Sale', path: '/sale/newsale' },




  //   ]
  // },

  // {
  //   name: 'Vouchers',
  //   path: '/pages/vouchers',
  //   icon: 'file-text',
  //   dataTargetId: '#reports',
  //   submenu: [
  //     { name: 'Reciept Voucher', path: '/vouchers/recieptvoucher' },
  //     { name: 'Payment Voucher', path: '/vouchers/paymentvoucher' },

  //   ]
  // },
  // {
  //   name: 'Expenses',
  //   path: '/pages/expenses',
  //   icon: 'minus-circle',
  //   dataTargetId: '#reports',
  //   submenu: [
  //     { name: 'Add Expense', path: '/expenses/suppliersexpenses' },

  //   ]
  // },
  {
    name: 'Reports',
    path: '/pages/reports',
    icon: 'chart',
    dataTargetId: '#reports',
    submenu: [
      { name: 'Sale Report', path: '/reports/billhistory' },
      { name: 'Cashier Summary', path: '/reports/cashier-summary-report' },
      { name: 'Weekly Sales', path: '/reports/weekly-sales' },
      { name: 'Monthly Sales', path: '/reports/monthly-sales' },
      { name: 'Category Wise Sales', path: '/reports/categorywise-sales' },
      { name: 'Cash Drawer Report', path: '/reports/cash-drawer-report' },
      // { name: 'Agents Ledger', path: '/reports/agentledger' },
      { name: 'Day Close', path: '/reports/dayclose' },
      { name: 'Day Close Summary', path: '/reports/day-close-summary' },

    ]
  },
  

  {
    name: 'Users',
    path: '/pages/users',
    icon: 'account-circle',
    dataTargetId: '#users',
    submenu: [
      { name: 'New User', path: '/users/newuser' },
      { name: 'Edit Profile', path: '/users/editprofile' },

    ]
  },

  {
    name: 'Setting',
    path: '/setting',
    icon: 'settings',
    dataTargetId: '#inventory',
    submenu: [
      { name: 'Core Setting', path: '/setting/coresetting' },
      { name: 'Ads Management', path: '/setting/ads-management' },
      { name: 'Company Info', path: '/setting/companyinfo' },
      { name: 'Taxes', path: '/setting/taxes' },
      { name: 'Units', path: '/setting/units' },

    ]
  },
      {
    name: 'My profile',
    path: '/pages/profile',
    icon: 'account-circle',
    dataTargetId: '#profile',
    submenu: [
      { name: 'Change Password', path: '/users/editprofile' },
      { name: 'Logout', path: '/logout' },

    ]
  },
  // {
  //   name: 'Subscription',
  //   path: '/subscription',
  //   icon: 'card-membership',
  //   dataTargetId: '#subscription'
  // },
  //   { name: 'Logout', 
  //     path: '/logout', 
  //     icon: 'sign-in', 
  //     dataTargetId: '#logout' ,
  //     "signOut": true
  //  }
];
const getMenuItems = (usertype) => {
  if (usertype === "Cashier")
    {
    return fullMenu
      .filter(item => ["Dashboard", "Sale", "Reports", "Vouchers", "Logout"].includes(item.name))
      .map(item => {
        if (item.submenu) 
          {
          const allowedSubmenuNames = {
            Sale: ["POS","Retail"],
            Reports: ["Sale Report", "Supplier Ledger", "Customer Ledger", "Reciept Voucher", "Payment Voucher"],
          };
          const filteredSubmenu = allowedSubmenuNames[item.name]
            ? item.submenu.filter(sub => allowedSubmenuNames[item.name].includes(sub.name))
            : item.submenu;
          return { ...item, submenu: filteredSubmenu };
        }
        return item;
      });
  }

  if (usertype === "Account") {
    return fullMenu
      .filter(item => ["Dashboard", "Reports", "Logout"].includes(item.name))
      .map(item => {
        if (item.name === "Reports" && item.submenu) {
          // Show full Reports submenu for Account
          return { ...item };
        }
        return item;
      });
  }

  // Default for Admin or other full-access users
  return fullMenu;
};


export default getMenuItems;
